import styled from "styled-components";
import { Card } from "react-bootstrap";
import { Checkbox as C, Rating as R } from "../../components";
import { STYLES } from "../../constants";

export const ApplyFilter = styled("div")`
  position: fixed;
  width: 100%;
  bottom: 0;
`;

export const Loader = styled("div")`
  padding: 15px;
  text-align: center;
  position: absolute;
  background-color: rgba(255, 255, 255, 0.75);
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  & > div {
    position: sticky;
    top: 50vh;
  }
`;

export const CardImg = styled(Card.Img)`
  object-fit: cover;
  height: 115px;
  margin-top: 0;
  margin-bottom: 0;
`;

export const Checkbox = styled(C)`
  .custom-control-input:disabled:checked ~ .custom-control-label::before {
    border-color: ${STYLES.color.grey} !important;
    background-color: ${STYLES.color.grey} !important;
  }
  @media (max-width: ${STYLES.screen.sm}) {
    label {
      font-size: 18px;
    }
  }
`;

export const BadgePremium = styled("div")`
  position: absolute;
  right: 0;
  top: 15px;
  background-color: ${STYLES.color.blue};
  color: #ffffff;
  font-size: 14px;
  padding: 10px 12px;
`;

export const PagerNav = styled("span")`
  color: ${STYLES.color.greyDark};
  cursor: pointer;
  ${({ disabled }) =>
    disabled && `point-events: none; cursor: auto; color: #cbcbcb;`}
`;

export const FilterTopBar = styled("section")`
  font-size: 19px;

  svg {
    position: absolute;
    font-size: 24px;
    right: 25px;
  }
`;

export const FilterWrap = styled("section")`
  @media (max-width: ${STYLES.screen.sm}) {
    overflow: auto;
    display: block;
    width: 100vw;
    height: 100vh;
    transform: translateX(-100vh);
    position: fixed;
    top: 0;
    left: 0;
    background: #ffffff;
    z-index: 10;
    padding-bottom: 100px;
    ${({ filterOpened }) => filterOpened && `transform: inherit`}
  }
`;

export const Grid = styled("div")`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 22px 40px;

  @media (max-width: ${STYLES.screen.lg}) {
    grid-template-columns: 1fr 1fr;
    grid-gap: 30px 30px;
  }
  @media (max-width: ${STYLES.screen.md}) {
    grid-template-columns: 1fr;
    grid-gap: 30px 30px;
  }
  @media (max-width: ${STYLES.screen.sm}) {
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px 10px;
  }
`;

export const SelectWrap = styled("div")`
  position: relative;

  &:before {
    ${({ isIcon, primary = STYLES.color.blue }) =>
      isIcon &&
      `
       display: block;
       content: url("
        data:image/svg+xml,%0A%3Csvg
        xmlns='http://www.w3.org/2000/svg'
        width='21'
        height='21'
        stroke='${primary.replace("#", "%23")}' 
        viewBox='0 0 24 24' 
        fill='none'
        stroke-width='2'
        stroke-linecap='round'
        stroke-linejoin='round'
        class='feather feather-filter'%3E%3Cpolygon
        points='22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3'%3E%3C/polygon%3E%3C/svg%3E
       "); 
       color: ${primary};
       border: 1px solid ${primary};
       line-height: 1;
       padding: 11px 9px 7px;`}
  }

  select {
    border: none;
    outline: none;
    font-weight: bold;
    background: none;
    max-width: inherit;
    width: inherit;
    padding: inherit;
    padding-bottom: 3px;
    color: black;
    box-shadow: none;
    font-size: 16px;

    ${({ isIcon }) =>
      isIcon &&
      `& {
          text-indent: -9999px;
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          position: absolute;
          position: absolute;
          top: 0;
          right: 0;
          width: 100%;
          height: 100%;
        }
        &::-ms-expand {
            display: none;
        }`}
  }
`;

export const Navigation = styled("section")`
  color: ${STYLES.color.greyDark};
  svg {
    font-size: 27px;
  }
`;

export const TextWithIcon = styled("div")`
  display: flex;
  svg {
    flex: none;
    margin-right: 3px;
    margin-top: 4px;
  }
`;

export const Container = styled("div")`
  display: flex;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 20px 15px;

  @media (max-width: ${STYLES.screen.sm}) {
    display: block;
  }
`;

export const Sidebar = styled("aside")`
  width: 100%;
  max-width: 280px;
  margin-right: 55px;

  @media (max-width: ${STYLES.screen.sm}) {
    max-width: 100%;
    margin: 0;
  }
`;

export const TitleLink = styled("a")`
  display: block;
  font-size: 19px;
  font-weight: bold;
  color: #3377cc;

  @media (max-width: ${STYLES.screen.sm}) {
    font-size: 16px;
    line-height: 20px;
  }
`;

export const Rating = styled(R)`
  font-size: 28px;
  line-height: 11px;

  @media (max-width: ${STYLES.screen.sm}) {
    font-size: 16px;
  }
`;

export const ButtonLink = styled("div")`
  font-weight: 400;
  color: #007bff;
  text-decoration: none;
  cursor: pointer;
  display: inline-block;
  padding: 12px 20px;
  font-size: 16px;
  line-height: 20px;
  &:hover {
    color: #0056b3;
    text-decoration: underline;
  }
`;

export const FilterTitle = styled("div")`
  line-height: 1;
  font-weight: bold;
  font-size: 18px;

  @media (max-width: ${STYLES.screen.sm}) {
    padding-top: 10px;
    padding-bottom: 10px;
    font-size: 20px;
  }

  .lock {
    color: ${STYLES.color.grey};
  }

  ${({ nested }) => nested && `font-size: 16px; font-weight: 400;`}
`;

const Counter = styled("div")`
  width: 25px;
  line-height: 1;
  margin-left: 5px;
  white-space: nowrap;
`;

const S = {
  FilterTitle,
  ButtonLink,
  ApplyFilter,
  Loader,
  CardImg,
  Checkbox,
  BadgePremium,
  PagerNav,
  FilterTopBar,
  FilterWrap,
  Grid,
  SelectWrap,
  Navigation,
  TextWithIcon,
  Container,
  Sidebar,
  TitleLink,
  Counter,
  Rating
};

export default S;
